/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import pharmacyReturnBillPayment from 'app/entities/pharmacy-return-bill-payment/pharmacy-return-bill-payment.reducer';
import hospitalOPBillItem from 'app/entities/hospital-op-bill-item/hospital-op-bill-item.reducer';
import personName from 'app/entities/person-name/person-name.reducer';
import diaglabSampleItemStatus from 'app/entities/diaglab-sample-item-status/diaglab-sample-item-status.reducer';
import admission from 'app/entities/admission/admission.reducer';
import admissionAdvice from 'app/entities/admission-advice/admission-advice.reducer';
import admissionEMContacts from 'app/entities/admission-em-contacts/admission-em-contacts.reducer';
import aldreteScore from 'app/entities/aldrete-score/aldrete-score.reducer';
import allergyLegend from 'app/entities/allergy-legend/allergy-legend.reducer';
import allergySymptom from 'app/entities/allergy-symptom/allergy-symptom.reducer';
import apgarScore from 'app/entities/apgar-score/apgar-score.reducer';
import appointmentHistory from 'app/entities/appointment-history/appointment-history.reducer';
import appointmentStatus from 'app/entities/appointment-status/appointment-status.reducer';
import appointments from 'app/entities/appointments/appointments.reducer';
import assessmentAnswer from 'app/entities/assessment-answer/assessment-answer.reducer';
import assessmentQuestion from 'app/entities/assessment-question/assessment-question.reducer';
import atendant from 'app/entities/atendant/atendant.reducer';
import bed from 'app/entities/bed/bed.reducer';
import bedAllotment from 'app/entities/bed-allotment/bed-allotment.reducer';
import behaviouralPainScore from 'app/entities/behavioural-pain-score/behavioural-pain-score.reducer';
import birthHistory from 'app/entities/birth-history/birth-history.reducer';
import bookingType from 'app/entities/booking-type/booking-type.reducer';
import cashTransaction from 'app/entities/cash-transaction/cash-transaction.reducer';
import cholesterol from 'app/entities/cholesterol/cholesterol.reducer';
import chronicCondition from 'app/entities/chronic-condition/chronic-condition.reducer';
import combousers from 'app/entities/combousers/combousers.reducer';
import conceptDataType from 'app/entities/concept-data-type/concept-data-type.reducer';
import consumable from 'app/entities/consumable/consumable.reducer';
import consumableGroup from 'app/entities/consumable-group/consumable-group.reducer';
import consumableOrder from 'app/entities/consumable-order/consumable-order.reducer';
import consumableOrderItem from 'app/entities/consumable-order-item/consumable-order-item.reducer';
import contactDetails from 'app/entities/contact-details/contact-details.reducer';
import device from 'app/entities/device/device.reducer';
import deviceManufacurer from 'app/entities/device-manufacurer/device-manufacurer.reducer';
import deviceType from 'app/entities/device-type/device-type.reducer';
import diagLab from 'app/entities/diag-lab/diag-lab.reducer';
import diaglabEquipment from 'app/entities/diaglab-equipment/diaglab-equipment.reducer';
import diagLabPanel from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import diagLabPanelItem from 'app/entities/diag-lab-panel-item/diag-lab-panel-item.reducer';
import diaglabAssistant from 'app/entities/diaglab-assistant/diaglab-assistant.reducer';
import diaglabBill from 'app/entities/diaglab-bill/diaglab-bill.reducer';
import diaglabBillItem from 'app/entities/diaglab-bill-item/diaglab-bill-item.reducer';
import diaglabBillPayment from 'app/entities/diaglab-bill-payment/diaglab-bill-payment.reducer';
import diaglabHistory from 'app/entities/diaglab-history/diaglab-history.reducer';
import diaglabPricing from 'app/entities/diaglab-pricing/diaglab-pricing.reducer';
import diaglabSampleItem from 'app/entities/diaglab-sample-item/diaglab-sample-item.reducer';
import diaglabSample from 'app/entities/diaglab-sample/diaglab-sample.reducer';
import diagnosisHistory from 'app/entities/diagnosis-history/diagnosis-history.reducer';
import dischargeSummary from 'app/entities/discharge-summary/discharge-summary.reducer';
import doctor from 'app/entities/doctor/doctor.reducer';
import doctorAccess from 'app/entities/doctor-access/doctor-access.reducer';
import doctorAssociation from 'app/entities/doctor-association/doctor-association.reducer';
import doctorAvailability from 'app/entities/doctor-availability/doctor-availability.reducer';
import doctorCharges from 'app/entities/doctor-charges/doctor-charges.reducer';
import doctorDetails from 'app/entities/doctor-details/doctor-details.reducer';
import doctorDiaglabAssociation from 'app/entities/doctor-diaglab-association/doctor-diaglab-association.reducer';
import doctorEspecialty from 'app/entities/doctor-especialty/doctor-especialty.reducer';
import doctorHospitalAssociation from 'app/entities/doctor-hospital-association/doctor-hospital-association.reducer';
import duration from 'app/entities/duration/duration.reducer';
import equipment from 'app/entities/equipment/equipment.reducer';
import equipmentAllotment from 'app/entities/equipment-allotment/equipment-allotment.reducer';
import equipmentIP from 'app/entities/equipment-ip/equipment-ip.reducer';
import equipmentIPCharges from 'app/entities/equipment-ip-charges/equipment-ip-charges.reducer';
import especialty from 'app/entities/especialty/especialty.reducer';
import flaccScore from 'app/entities/flacc-score/flacc-score.reducer';
import globalProperty from 'app/entities/global-property/global-property.reducer';
import glucoUser from 'app/entities/gluco-user/gluco-user.reducer';
import glucose from 'app/entities/glucose/glucose.reducer';
import growthLegend from 'app/entities/growth-legend/growth-legend.reducer';
import gynicHistory from 'app/entities/gynic-history/gynic-history.reducer';
import hb1ac from 'app/entities/hb-1-ac/hb-1-ac.reducer';
import hospital from 'app/entities/hospital/hospital.reducer';
import hospitalAccess from 'app/entities/hospital-access/hospital-access.reducer';
import hospitalAccountant from 'app/entities/hospital-accountant/hospital-accountant.reducer';
import hospitalAppointments from 'app/entities/hospital-appointments/hospital-appointments.reducer';
import hospitalAssistant from 'app/entities/hospital-assistant/hospital-assistant.reducer';
import hospitalBill from 'app/entities/hospital-bill/hospital-bill.reducer';
import hospitalBillDiscount from 'app/entities/hospital-bill-discount/hospital-bill-discount.reducer';
import hospitalBillItem from 'app/entities/hospital-bill-item/hospital-bill-item.reducer';
import hospitalInstitution from 'app/entities/hospital-institution/hospital-institution.reducer';
import hospitalManager from 'app/entities/hospital-manager/hospital-manager.reducer';
import hospitalPayment from 'app/entities/hospital-payment/hospital-payment.reducer';
import hospitalProcedure from 'app/entities/hospital-procedure/hospital-procedure.reducer';
import iCD10Diagnosis from 'app/entities/icd-10-diagnosis/icd-10-diagnosis.reducer';
import iCD10Procedure from 'app/entities/icd-10-procedure/icd-10-procedure.reducer';
import icdDetails from 'app/entities/icd-details/icd-details.reducer';
import imageTests from 'app/entities/image-tests/image-tests.reducer';
import implant from 'app/entities/implant/implant.reducer';
import implantGroup from 'app/entities/implant-group/implant-group.reducer';
import implantOrder from 'app/entities/implant-order/implant-order.reducer';
import implantOrderItem from 'app/entities/implant-order-item/implant-order-item.reducer';
import implantProperty from 'app/entities/implant-property/implant-property.reducer';
import instance from 'app/entities/instance/instance.reducer';
import institution from 'app/entities/institution/institution.reducer';
import insuranceClaim from 'app/entities/insurance-claim/insurance-claim.reducer';
import insuranceClaimHistory from 'app/entities/insurance-claim-history/insurance-claim-history.reducer';
import insuranceClaimItem from 'app/entities/insurance-claim-item/insurance-claim-item.reducer';
import insurancePolicy from 'app/entities/insurance-policy/insurance-policy.reducer';
import intraOPChart from 'app/entities/intra-op-chart/intra-op-chart.reducer';
import intraOPCount from 'app/entities/intra-op-count/intra-op-count.reducer';
import intraOPNursingRecord from 'app/entities/intra-op-nursing-record/intra-op-nursing-record.reducer';
import intraOPPack from 'app/entities/intra-op-pack/intra-op-pack.reducer';
import intraOPRecovery from 'app/entities/intra-op-recovery/intra-op-recovery.reducer';
import ketone from 'app/entities/ketone/ketone.reducer';
import labAccess from 'app/entities/lab-access/lab-access.reducer';
import labDepartment from 'app/entities/lab-department/lab-department.reducer';
import labDepartmentItem from 'app/entities/lab-department-item/lab-department-item.reducer';
import labHospitalAssociation from 'app/entities/lab-hospital-association/lab-hospital-association.reducer';
import labItemMeasure from 'app/entities/lab-item-measure/lab-item-measure.reducer';
import labPrescription from 'app/entities/lab-prescription/lab-prescription.reducer';
import labTestCategory from 'app/entities/lab-test-category/lab-test-category.reducer';
import labTestCategoryGroup from 'app/entities/lab-test-category-group/lab-test-category-group.reducer';
import labTestCategoryItem from 'app/entities/lab-test-category-item/lab-test-category-item.reducer';
import labTestGroupItem from 'app/entities/lab-test-group-item/lab-test-group-item.reducer';
import labTestItem from 'app/entities/lab-test-item/lab-test-item.reducer';
import labTestItemLimit from 'app/entities/lab-test-item-limit/lab-test-item-limit.reducer';
import mPPS from 'app/entities/mpps/mpps.reducer';
import mWLItem from 'app/entities/mwl-item/mwl-item.reducer';
import meal from 'app/entities/meal/meal.reducer';
import mealAdvise from 'app/entities/meal-advise/meal-advise.reducer';
import mealDetails from 'app/entities/meal-details/meal-details.reducer';
import mealNutrition from 'app/entities/meal-nutrition/meal-nutrition.reducer';
import mealPlan from 'app/entities/meal-plan/meal-plan.reducer';
import mealSchedule from 'app/entities/meal-schedule/meal-schedule.reducer';
import medicalAssociation from 'app/entities/medical-association/medical-association.reducer';
import medicalHistory from 'app/entities/medical-history/medical-history.reducer';
import medicationDetails from 'app/entities/medication-details/medication-details.reducer';
import medicationMedicines from 'app/entities/medication-medicines/medication-medicines.reducer';
import medicationSchedule from 'app/entities/medication-schedule/medication-schedule.reducer';
import medicationScheduleDetails from 'app/entities/medication-schedule-details/medication-schedule-details.reducer';
import medicine from 'app/entities/medicine/medicine.reducer';
import moduleLogo from 'app/entities/module-logo/module-logo.reducer';
import nipsScore from 'app/entities/nips-score/nips-score.reducer';
import nurse from 'app/entities/nurse/nurse.reducer';
import nursingNotes from 'app/entities/nursing-notes/nursing-notes.reducer';
import nutritionIP from 'app/entities/nutrition-ip/nutrition-ip.reducer';
import nutritionOrder from 'app/entities/nutrition-order/nutrition-order.reducer';
import nutritionOrderItem from 'app/entities/nutrition-order-item/nutrition-order-item.reducer';
import nutritionPlan from 'app/entities/nutrition-plan/nutrition-plan.reducer';
import nutritionPlanIP from 'app/entities/nutrition-plan-ip/nutrition-plan-ip.reducer';
import nutritionist from 'app/entities/nutritionist/nutritionist.reducer';
import nutrtion from 'app/entities/nutrtion/nutrtion.reducer';
import nutrtiontags from 'app/entities/nutrtiontags/nutrtiontags.reducer';
import obstetricEvent from 'app/entities/obstetric-event/obstetric-event.reducer';
import opMedication from 'app/entities/op-medication/op-medication.reducer';
import otherVitals from 'app/entities/other-vitals/other-vitals.reducer';
import paediatricParams from 'app/entities/paediatric-params/paediatric-params.reducer';
import patientCondition from 'app/entities/patient-condition/patient-condition.reducer';
import patientConditionCheckUp from 'app/entities/patient-condition-check-up/patient-condition-check-up.reducer';
import patientIdentifierName from 'app/entities/patient-identifier-name/patient-identifier-name.reducer';
import patientIdentifier from 'app/entities/patient-identifier/patient-identifier.reducer';
import patientIdentifierType from 'app/entities/patient-identifier-type/patient-identifier-type.reducer';
import patientMarker from 'app/entities/patient-marker/patient-marker.reducer';
import patientNutritionPlan from 'app/entities/patient-nutrition-plan/patient-nutrition-plan.reducer';
import patientProcedure from 'app/entities/patient-procedure/patient-procedure.reducer';
import patientProcedureConsumable from 'app/entities/patient-procedure-consumable/patient-procedure-consumable.reducer';
import patientProcedureImplant from 'app/entities/patient-procedure-implant/patient-procedure-implant.reducer';
import patientProcedureMedicine from 'app/entities/patient-procedure-medicine/patient-procedure-medicine.reducer';
import patientProcedureOrder from 'app/entities/patient-procedure-order/patient-procedure-order.reducer';
import patientProcedurePlan from 'app/entities/patient-procedure-plan/patient-procedure-plan.reducer';
import patientProcedureInvestigation from 'app/entities/patient-procedure-investigation/patient-procedure-investigation.reducer';
import patientSurvey from 'app/entities/patient-survey/patient-survey.reducer';
import patientSurveySections from 'app/entities/patient-survey-sections/patient-survey-sections.reducer';
import patientVolunteer from 'app/entities/patient-volunteer/patient-volunteer.reducer';
import paymentScheme from 'app/entities/payment-scheme/payment-scheme.reducer';
import patientName from 'app/entities/patient-name/patient-name.reducer';
import pharmacist from 'app/entities/pharmacist/pharmacist.reducer';
import pharmacy from 'app/entities/pharmacy/pharmacy.reducer';
import pharmacyAccess from 'app/entities/pharmacy-access/pharmacy-access.reducer';
import pharmacyBill from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import pharmacyBillItem from 'app/entities/pharmacy-bill-item/pharmacy-bill-item.reducer';
import pharmacyBillPayment from 'app/entities/pharmacy-bill-payment/pharmacy-bill-payment.reducer';
import pharmacyConsumableBillItem from 'app/entities/pharmacy-consumable-bill-item/pharmacy-consumable-bill-item.reducer';
import pharmacyConsumableRefundBillItem from 'app/entities/pharmacy-consumable-refund-bill-item/pharmacy-consumable-refund-bill-item.reducer';
import pharmacyConsumableStock from 'app/entities/pharmacy-consumable-stock/pharmacy-consumable-stock.reducer';
import pharmacyDrugBrandNames from 'app/entities/pharmacy-drug-brand-names/pharmacy-drug-brand-names.reducer';
import pharmacyHistory from 'app/entities/pharmacy-history/pharmacy-history.reducer';
import pharmacyHospitalAssociation from 'app/entities/pharmacy-hospital-association/pharmacy-hospital-association.reducer';
import pharmacyImplantBillItem from 'app/entities/pharmacy-implant-bill-item/pharmacy-implant-bill-item.reducer';
import pharmacyImplantRefundBillItem from 'app/entities/pharmacy-implant-refund-bill-item/pharmacy-implant-refund-bill-item.reducer';
import pharmacyImplantStock from 'app/entities/pharmacy-implant-stock/pharmacy-implant-stock.reducer';
import pharmacyPaymentHistory from 'app/entities/pharmacy-payment-history/pharmacy-payment-history.reducer';
import pharmacyRefundBill from 'app/entities/pharmacy-refund-bill/pharmacy-refund-bill.reducer';
import pharmacyRefundBillItem from 'app/entities/pharmacy-refund-bill-item/pharmacy-refund-bill-item.reducer';
import pharmacyRefundPayment from 'app/entities/pharmacy-refund-payment/pharmacy-refund-payment.reducer';
import pharmacyStock from 'app/entities/pharmacy-stock/pharmacy-stock.reducer';
import pharmacyStockBill from 'app/entities/pharmacy-stock-bill/pharmacy-stock-bill.reducer';
import pharmacySuppliers from 'app/entities/pharmacy-suppliers/pharmacy-suppliers.reducer';
import physioCategory from 'app/entities/physio-category/physio-category.reducer';
import physioCategoryItem from 'app/entities/physio-category-item/physio-category-item.reducer';
import physioItem from 'app/entities/physio-item/physio-item.reducer';
import physioOrder from 'app/entities/physio-order/physio-order.reducer';
import physioOrderItem from 'app/entities/physio-order-item/physio-order-item.reducer';
import physioTherapist from 'app/entities/physio-therapist/physio-therapist.reducer';
import postOPInstruction from 'app/entities/post-op-instruction/post-op-instruction.reducer';
import postOPRecoveryRecord from 'app/entities/post-op-recovery-record/post-op-recovery-record.reducer';
import postOPSurgeonNotes from 'app/entities/post-op-surgeon-notes/post-op-surgeon-notes.reducer';
import postOpRecovery from 'app/entities/post-op-recovery/post-op-recovery.reducer';
import postOpRecoveryDischarge from 'app/entities/post-op-recovery-discharge/post-op-recovery-discharge.reducer';
import preAssessment from 'app/entities/pre-assessment/pre-assessment.reducer';
import preOPTimeOut from 'app/entities/pre-op-time-out/pre-op-time-out.reducer';
import preOpAddlAssessment from 'app/entities/pre-op-addl-assessment/pre-op-addl-assessment.reducer';
import preOpAnaesthesiaChart from 'app/entities/pre-op-anaesthesia-chart/pre-op-anaesthesia-chart.reducer';
import preOpAssessment from 'app/entities/pre-op-assessment/pre-op-assessment.reducer';
import preOpCheckList from 'app/entities/pre-op-check-list/pre-op-check-list.reducer';
import preOpInstructions from 'app/entities/pre-op-instructions/pre-op-instructions.reducer';
import preOpReviewPAC from 'app/entities/pre-op-review-pac/pre-op-review-pac.reducer';
import preOpSignIn from 'app/entities/pre-op-sign-in/pre-op-sign-in.reducer';
import prescription from 'app/entities/prescription/prescription.reducer';
import prescriptionSpecVital from 'app/entities/prescription-spec-vital/prescription-spec-vital.reducer';
import pressure from 'app/entities/pressure/pressure.reducer';
import procedureBloodProducts from 'app/entities/procedure-blood-products/procedure-blood-products.reducer';
import procedureConsumable from 'app/entities/procedure-consumable/procedure-consumable.reducer';
import procedureImplant from 'app/entities/procedure-implant/procedure-implant.reducer';
import procedureMedicine from 'app/entities/procedure-medicine/procedure-medicine.reducer';
import procedureMonitors from 'app/entities/procedure-monitors/procedure-monitors.reducer';
import procedurePrice from 'app/entities/procedure-price/procedure-price.reducer';
import procedureInvestigation from 'app/entities/procedure-investigation/procedure-investigation.reducer';
import providedItem from 'app/entities/provided-item/provided-item.reducer';
import radiologyBillItem from 'app/entities/radiology-bill-item/radiology-bill-item.reducer';
import radiologyPricing from 'app/entities/radiology-pricing/radiology-pricing.reducer';
import radiologyReport from 'app/entities/radiology-report/radiology-report.reducer';
import radiologyReportTemplate from 'app/entities/radiology-report-template/radiology-report-template.reducer';
import radiologyStudy from 'app/entities/radiology-study/radiology-study.reducer';
import recipe from 'app/entities/recipe/recipe.reducer';
import recipeTags from 'app/entities/recipe-tags/recipe-tags.reducer';
import referral from 'app/entities/referral/referral.reducer';
import relation from 'app/entities/relation/relation.reducer';
import relatives from 'app/entities/relatives/relatives.reducer';
import reminderOptions from 'app/entities/reminder-options/reminder-options.reducer';
import reminders from 'app/entities/reminders/reminders.reducer';
import roles from 'app/entities/roles/roles.reducer';
import room from 'app/entities/room/room.reducer';
import saluation from 'app/entities/saluation/saluation.reducer';
import series from 'app/entities/series/series.reducer';
import specialityVitals from 'app/entities/speciality-vitals/speciality-vitals.reducer';
import study from 'app/entities/study/study.reducer';
import subscriptionBilling from 'app/entities/subscription-billing/subscription-billing.reducer';
import subscriptionPayment from 'app/entities/subscription-payment/subscription-payment.reducer';
import subscriptionPlan from 'app/entities/subscription-plan/subscription-plan.reducer';
import surveyAnswer from 'app/entities/survey-answer/survey-answer.reducer';
import surveyComments from 'app/entities/survey-comments/survey-comments.reducer';
import surveyHeaders from 'app/entities/survey-headers/survey-headers.reducer';
import surveyInputType from 'app/entities/survey-input-type/survey-input-type.reducer';
import surveyOptionChoice from 'app/entities/survey-option-choice/survey-option-choice.reducer';
import surveyOptionGroup from 'app/entities/survey-option-group/survey-option-group.reducer';
import surveyQuestion from 'app/entities/survey-question/survey-question.reducer';
import surveyQuestionOption from 'app/entities/survey-question-option/survey-question-option.reducer';
import surveySections from 'app/entities/survey-sections/survey-sections.reducer';
import surveyUnitsOfMeasure from 'app/entities/survey-units-of-measure/survey-units-of-measure.reducer';
import templateDiagnosis from 'app/entities/template-diagnosis/template-diagnosis.reducer';
import templateInvestigation from 'app/entities/template-investigation/template-investigation.reducer';
import templateMedication from 'app/entities/template-medication/template-medication.reducer';
import templatePrescription from 'app/entities/template-prescription/template-prescription.reducer';
import templateSchedule from 'app/entities/template-schedule/template-schedule.reducer';
import treatmentHistory from 'app/entities/treatment-history/treatment-history.reducer';
import treatmentNotes from 'app/entities/treatment-notes/treatment-notes.reducer';
import treatmentPlan from 'app/entities/treatment-plan/treatment-plan.reducer';
import userAdditionalHistory from 'app/entities/user-additional-history/user-additional-history.reducer';
import userAllergies from 'app/entities/user-allergies/user-allergies.reducer';
import userLabItemEnum from 'app/entities/user-lab-item-enum/user-lab-item-enum.reducer';
import userLabTestItem from 'app/entities/user-lab-test-item/user-lab-test-item.reducer';
import userPanelItem from 'app/entities/user-panel-item/user-panel-item.reducer';
import userRoles from 'app/entities/user-roles/user-roles.reducer';
import userVaccinationScheduleDetails from 'app/entities/user-vaccination-schedule-details/user-vaccination-schedule-details.reducer';
import vaccination from 'app/entities/vaccination/vaccination.reducer';
import vaccinationSchedule from 'app/entities/vaccination-schedule/vaccination-schedule.reducer';
import vaccinationScheduleDetails from 'app/entities/vaccination-schedule-details/vaccination-schedule-details.reducer';
import vitals from 'app/entities/vitals/vitals.reducer';
import volunteerVisits from 'app/entities/volunteer-visits/volunteer-visits.reducer';
import ward from 'app/entities/ward/ward.reducer';
import wardCharges from 'app/entities/ward-charges/ward-charges.reducer';
import weight from 'app/entities/weight/weight.reducer';
import wongBakersPainScore from 'app/entities/wong-bakers-pain-score/wong-bakers-pain-score.reducer';
import entityAttribute from 'app/entities/entity-attribute/entity-attribute.reducer';
import pharmacyLimit from 'app/entities/pharmacy-limit/pharmacy-limit.reducer';
import operationTheatre from 'app/entities/operation-theatre/operation-theatre.reducer';
import surgicalAppointment from 'app/entities/surgical-appointment/surgical-appointment.reducer';
import surgicalAppointmentAttributeType from 'app/entities/surgical-appointment-attribute-type/surgical-appointment-attribute-type.reducer';
import surgicalAppointmentAttribute from 'app/entities/surgical-appointment-attribute/surgical-appointment-attribute.reducer';
import pharmacyReturnBill from 'app/entities/pharmacy-return-bill/pharmacy-return-bill.reducer';
import pharmacyReturnBillItem from 'app/entities/pharmacy-return-bill-item/pharmacy-return-bill-item.reducer';
import pharmacyConsumableReturnBillItem from 'app/entities/pharmacy-consumable-return-bill-item/pharmacy-consumable-return-bill-item.reducer';
import pharmacyImplantReturnBillItem from 'app/entities/pharmacy-implant-return-bill-item/pharmacy-implant-return-bill-item.reducer';
import pharmacyVendorPaymentTracker from 'app/entities/pharmacy-vendor-payment-tracker/pharmacy-vendor-payment-tracker.reducer';
import oPCharge from 'app/entities/op-charge/op-charge.reducer';
import pharmacyCredit from 'app/entities/pharmacy-credit/pharmacy-credit.reducer';
import packageSubscription from 'app/entities/package-subscription/package-subscription.reducer';
import packageSubscriber from 'app/entities/package-subscriber/package-subscriber.reducer';
import packageSubscriptionDiscount from 'app/entities/package-subscription-discount/package-subscription-discount.reducer';
import packagePaymentHistory from 'app/entities/package-payment-history/package-payment-history.reducer';
import patientAccessGroup from 'app/entities/patient-access-group/patient-access-group.reducer';
import pharmacyAuditSummary from 'app/entities/pharmacy-audit-summary/pharmacy-audit-summary.reducer';
import pharmacyAuditItem from 'app/entities/pharmacy-audit-item/pharmacy-audit-item.reducer';
import packageMedicine from 'app/entities/package-medicine/package-medicine.reducer';
import customerCareExecutive from 'app/entities/customer-care-executive/customer-care-executive.reducer';
import eventImage from 'app/entities/event-image/event-image.reducer';
import dentalTooth from 'app/entities/dental-tooth/dental-tooth.reducer';
import dentalSurface from 'app/entities/dental-surface/dental-surface.reducer';
import dentalToothSurface from 'app/entities/dental-tooth-surface/dental-tooth-surface.reducer';
import dentalMouthItem from 'app/entities/dental-mouth-item/dental-mouth-item.reducer';
import dentalSurfaceErosion from 'app/entities/dental-surface-erosion/dental-surface-erosion.reducer';
import dentalExamAndTreatment from 'app/entities/dental-exam-and-treatment/dental-exam-and-treatment.reducer';
import pharmacyKit from 'app/entities/pharmacy-kit/pharmacy-kit.reducer';
import pharmacyKitItem from 'app/entities/pharmacy-kit-item/pharmacy-kit-item.reducer';
import procedureEpisode from 'app/entities/procedure-episode/procedure-episode.reducer';
import patientProcedureEpisode from 'app/entities/patient-procedure-episode/patient-procedure-episode.reducer';
import treatmentProcedure from 'app/entities/treatment-procedure/treatment-procedure.reducer';
import pharmacyStockClosure from 'app/entities/pharmacy-stock-closure/pharmacy-stock-closure.reducer';
import lensSpecification from 'app/entities/lens-specification/lens-specification.reducer';
import lensPrescription from 'app/entities/lens-prescription/lens-prescription.reducer';
import opProcedureOrder from 'app/entities/op-procedure-order/op-procedure-order.reducer';
import opProcedureOrderItem from 'app/entities/op-procedure-order-item/op-procedure-order-item.reducer';
import appointmentEpisode from 'app/entities/appointment-episode/appointment-episode.reducer';
import bleeding from 'app/entities/bleeding/bleeding.reducer';
import cervix from 'app/entities/cervix/cervix.reducer';
import cycleDay from 'app/entities/cycle-day/cycle-day.reducer';
import familyHistory from 'app/entities/family-history/family-history.reducer';
import gynaecHistory from 'app/entities/gynaec-history/gynaec-history.reducer';
import medicationHistory from 'app/entities/medication-history/medication-history.reducer';
import mensesEvent from 'app/entities/menses-event/menses-event.reducer';
import mucus from 'app/entities/mucus/mucus.reducer';
import ovulation from 'app/entities/ovulation/ovulation.reducer';
import pain from 'app/entities/pain/pain.reducer';
import pastMedicalHistory from 'app/entities/past-medical-history/past-medical-history.reducer';
import patientSymptomHistory from 'app/entities/patient-symptom-history/patient-symptom-history.reducer';
import postDeliveryMonitoring from 'app/entities/post-delivery-monitoring/post-delivery-monitoring.reducer';
import pregnancyCase from 'app/entities/pregnancy-case/pregnancy-case.reducer';
import pregnancyPrescription from 'app/entities/pregnancy-prescription/pregnancy-prescription.reducer';
import pregnancyVaccine from 'app/entities/pregnancy-vaccine/pregnancy-vaccine.reducer';
import habitsHistory from 'app/entities/habits-history/habits-history.reducer';
import sexualHistory from 'app/entities/sexual-history/sexual-history.reducer';
import specialitySymptomPreferences from 'app/entities/speciality-symptom-preferences/speciality-symptom-preferences.reducer';
import surgicalHistory from 'app/entities/surgical-history/surgical-history.reducer';
import symptom from 'app/entities/symptom/symptom.reducer';
import temperature from 'app/entities/temperature/temperature.reducer';
import trimesterObservation from 'app/entities/trimester-observation/trimester-observation.reducer';
import patientAttributeType from 'app/entities/patient-attribute-type/patient-attribute-type.reducer';
import patientAttribute from 'app/entities/patient-attribute/patient-attribute.reducer';
import paramedic from 'app/entities/paramedic/paramedic.reducer';
import paramedicReferral from 'app/entities/paramedic-referral/paramedic-referral.reducer';
import paramedicReferralCharge from 'app/entities/paramedic-referral-charge/paramedic-referral-charge.reducer';
import paramedicReferralPayment from 'app/entities/paramedic-referral-payment/paramedic-referral-payment.reducer';
import paramedicHospitalAssociation from 'app/entities/paramedic-hospital-association/paramedic-hospital-association.reducer';
import urlSlug from 'app/entities/url-slug/url-slug.reducer';
import facilityLocation from 'app/entities/facility-location/facility-location.reducer';
import paramedicAccess from 'app/entities/paramedic-access/paramedic-access.reducer';
import pharmacyStockIndentItem from 'app/entities/pharmacy-stock-indent-item/pharmacy-stock-indent-item.reducer';
import pharmacyStockIndentMap from 'app/entities/pharmacy-stock-indent-map/pharmacy-stock-indent-map.reducer';
import diagLabInventoryType from 'app/entities/diag-lab-inventory-type/diag-lab-inventory-type.reducer';
import diagLabInventory from 'app/entities/diag-lab-inventory/diag-lab-inventory.reducer';
import diagLabInventoryInvestigation from 'app/entities/diag-lab-inventory-investigation/diag-lab-inventory-investigation.reducer';
import diagLabSupplier from 'app/entities/diag-lab-supplier/diag-lab-supplier.reducer';
import pharmacyStockIndent from 'app/entities/pharmacy-stock-indent/pharmacy-stock-indent.reducer';
import diagLabInventoryCheckout from 'app/entities/diag-lab-inventory-checkout/diag-lab-inventory-checkout.reducer';
import language from 'app/entities/language/language.reducer';
import trimester from 'app/entities/trimester/trimester.reducer';
import paramedicOrder from 'app/entities/paramedic-order/paramedic-order.reducer';
import doctorLanguage from 'app/entities/doctor-language/doctor-language.reducer';
import laborIncident from 'app/entities/labor-incident/labor-incident.reducer';
import laborProgression from 'app/entities/labor-progression/labor-progression.reducer';
import trimesterObservationParam from 'app/entities/trimester-observation-param/trimester-observation-param.reducer';
import specVitalResult from 'app/entities/spec-vital-result/spec-vital-result.reducer';
import admissionAuxPatient from 'app/entities/admission-aux-patient/admission-aux-patient.reducer';
import admissionConsultant from 'app/entities/admission-consultant/admission-consultant.reducer';
import gynaecChecklist from 'app/entities/gynaec-checklist/gynaec-checklist.reducer';
import patientCategory from 'app/entities/patient-category/patient-category.reducer';
import miscCharges from 'app/entities/misc-charges/misc-charges.reducer';
import hospitalPatientCategoryAttributes from 'app/entities/hospital-patient-category-attributes/hospital-patient-category-attributes.reducer';
import hospPatientCatMiscCharges from 'app/entities/hosp-patient-cat-misc-charges/hosp-patient-cat-misc-charges.reducer';
import hospitalPatientAttribute from 'app/entities/hospital-patient-attribute/hospital-patient-attribute.reducer';
import doctorHospitalAttribute from 'app/entities/doctor-hospital-attribute/doctor-hospital-attribute.reducer';
import dayOff from 'app/entities/day-off/day-off.reducer';
import department from 'app/entities/department/department.reducer';
import nurseDepartment from 'app/entities/nurse-department/nurse-department.reducer';
import departmentNeed from 'app/entities/department-need/department-need.reducer';
import nurseAttribute from 'app/entities/nurse-attribute/nurse-attribute.reducer';
import schedule from 'app/entities/schedule/schedule.reducer';
import shift from 'app/entities/shift/shift.reducer';
import departmentWard from 'app/entities/department-ward/department-ward.reducer';
import paymentCommunity from 'app/entities/payment-community/payment-community.reducer';
import schemeCommunity from 'app/entities/scheme-community/scheme-community.reducer';
import departmentSpeciality from 'app/entities/department-speciality/department-speciality.reducer';
import diagLabInventoryBill from 'app/entities/diag-lab-inventory-bill/diag-lab-inventory-bill.reducer';
import symptomAttributePreference from 'app/entities/symptom-attribute-preference/symptom-attribute-preference.reducer';
import symptomAttribute from 'app/entities/symptom-attribute/symptom-attribute.reducer';
import patientSymptomAttribute from 'app/entities/patient-symptom-attribute/patient-symptom-attribute.reducer';
import conceptTerms from 'app/entities/concept-terms/concept-terms.reducer';
import userAttribute from 'app/entities/user-attribute/user-attribute.reducer';
import pharmacyConsumer from 'app/entities/pharmacy-consumer/pharmacy-consumer.reducer';
import pharmacyExternalOrder from 'app/entities/pharmacy-external-order/pharmacy-external-order.reducer';
import pharmacyExternalOrderItem from 'app/entities/pharmacy-external-order-item/pharmacy-external-order-item.reducer';
import pharmacyExternalOrderShipment from 'app/entities/pharmacy-external-order-shipment/pharmacy-external-order-shipment.reducer';
import pharmacyExternalOrderShipmentItem from 'app/entities/pharmacy-external-order-shipment-item/pharmacy-external-order-shipment-item.reducer';
import eye from 'app/entities/eye/eye.reducer';
import pharmacyMiscBillItem from 'app/entities/pharmacy-misc-bill-item/pharmacy-misc-bill-item.reducer';
import tumorMeasurement from 'app/entities/tumor-measurement/tumor-measurement.reducer';
import clinicalDictionaryType from 'app/entities/clinical-dictionary-type/clinical-dictionary-type.reducer';
import clinicalDictionary from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import tumor from 'app/entities/tumor/tumor.reducer';
import tumorSource from 'app/entities/tumor-source/tumor-source.reducer';
import treatmentTemplate from 'app/entities/treatment-template/treatment-template.reducer';
import treatmentTemplateComponent from 'app/entities/treatment-template-component/treatment-template-component.reducer';
import regimen from 'app/entities/regimen/regimen.reducer';
import regimenChecklistItem from 'app/entities/regimen-checklist-item/regimen-checklist-item.reducer';
import radiationType from 'app/entities/radiation-type/radiation-type.reducer';
import radiationTechnique from 'app/entities/radiation-technique/radiation-technique.reducer';
import dosageGuideline from 'app/entities/dosage-guideline/dosage-guideline.reducer';
import dosageDilution from 'app/entities/dosage-dilution/dosage-dilution.reducer';
import frequency from 'app/entities/frequency/frequency.reducer';
import sequence from 'app/entities/sequence/sequence.reducer';
import regimenDrug from 'app/entities/regimen-drug/regimen-drug.reducer';
import radiationSession from 'app/entities/radiation-session/radiation-session.reducer';
import organAtRisk from 'app/entities/organ-at-risk/organ-at-risk.reducer';
import radiationConstraint from 'app/entities/radiation-constraint/radiation-constraint.reducer';
import radiationBeamParameter from 'app/entities/radiation-beam-parameter/radiation-beam-parameter.reducer';
import radiationDosimetry from 'app/entities/radiation-dosimetry/radiation-dosimetry.reducer';
import regimenCycle from 'app/entities/regimen-cycle/regimen-cycle.reducer';
import regimenAdverseEvent from 'app/entities/regimen-adverse-event/regimen-adverse-event.reducer';
import drugConstraint from 'app/entities/drug-constraint/drug-constraint.reducer';
import treatmentDeliveryPlan from 'app/entities/treatment-delivery-plan/treatment-delivery-plan.reducer';
import treatmentRegimen from 'app/entities/treatment-regimen/treatment-regimen.reducer';
import treatmentCycle from 'app/entities/treatment-cycle/treatment-cycle.reducer';
import treatmentCycleCheckListItem from 'app/entities/treatment-cycle-check-list-item/treatment-cycle-check-list-item.reducer';
import treatmentDrug from 'app/entities/treatment-drug/treatment-drug.reducer';
import treatmentRadiation from 'app/entities/treatment-radiation/treatment-radiation.reducer';
import treatmentRadiationBeamParam from 'app/entities/treatment-radiation-beam-param/treatment-radiation-beam-param.reducer';
import treatmentRadiationDosimetry from 'app/entities/treatment-radiation-dosimetry/treatment-radiation-dosimetry.reducer';
import treatmentOrganAtRisk from 'app/entities/treatment-organ-at-risk/treatment-organ-at-risk.reducer';
import treatmentTumor from 'app/entities/treatment-tumor/treatment-tumor.reducer';
import treatmentRadiationTechnique from 'app/entities/treatment-radiation-technique/treatment-radiation-technique.reducer';
import treatmentContouring from 'app/entities/treatment-contouring/treatment-contouring.reducer';
import treatmentAssessment from 'app/entities/treatment-assessment/treatment-assessment.reducer';
import treatmentAdverseEvent from 'app/entities/treatment-adverse-event/treatment-adverse-event.reducer';
import tumorBoard from 'app/entities/tumor-board/tumor-board.reducer';
import tumorBoardMember from 'app/entities/tumor-board-member/tumor-board-member.reducer';
import tumorStaging from 'app/entities/tumor-staging/tumor-staging.reducer';
import tumorBoardOccurrenceParticipant from 'app/entities/tumor-board-occurrence-participant/tumor-board-occurrence-participant.reducer';
import tumorBoardOutcome from 'app/entities/tumor-board-outcome/tumor-board-outcome.reducer';
import tumorBoardParticipantOutcome from 'app/entities/tumor-board-participant-outcome/tumor-board-participant-outcome.reducer';
import tumorBoardReferral from 'app/entities/tumor-board-referral/tumor-board-referral.reducer';
import tumorBoardOccurrence from 'app/entities/tumor-board-occurrence/tumor-board-occurrence.reducer';
import tumorBoardPatient from 'app/entities/tumor-board-patient/tumor-board-patient.reducer';
import doctorAvailabilitySlot from 'app/entities/doctor-availability-slot/doctor-availability-slot.reducer';
import bedAllotmentCharge from 'app/entities/bed-allotment-charge/bed-allotment-charge.reducer';
import equipmentAllotmentCharge from 'app/entities/equipment-allotment-charge/equipment-allotment-charge.reducer';
import patientProcedureCharge from 'app/entities/patient-procedure-charge/patient-procedure-charge.reducer';
import productTag from 'app/entities/product-tag/product-tag.reducer';
import tenantPaymentGateway from 'app/entities/tenant-payment-gateway/tenant-payment-gateway.reducer';
import paymentGateway from 'app/entities/payment-gateway/payment-gateway.reducer';
import tenantGatewayTransaction from 'app/entities/tenant-gateway-transaction/tenant-gateway-transaction.reducer';
import pharmacySupplierAttribute from 'app/entities/pharmacy-supplier-attribute/pharmacy-supplier-attribute.reducer';
import intraOPInvestigation from 'app/entities/intra-op-investigation/intra-op-investigation.reducer';
import productAttributeType from 'app/entities/product-attribute-type/product-attribute-type.reducer';
import productAttribute from 'app/entities/product-attribute/product-attribute.reducer';
import sampleContainerType from 'app/entities/sample-container-type/sample-container-type.reducer';
import hospitalProcedureSpeciality from 'app/entities/hospital-procedure-speciality/hospital-procedure-speciality.reducer';
import workFlowProtocol from 'app/entities/work-flow-protocol/work-flow-protocol.reducer';
import workFlowStep from 'app/entities/work-flow-step/work-flow-step.reducer';
import workFlowProtocolLog from 'app/entities/work-flow-protocol-log/work-flow-protocol-log.reducer';
import accountingCurrency from 'app/entities/accounting-currency/accounting-currency.reducer';
import accountingTransaction from 'app/entities/accounting-transaction/accounting-transaction.reducer';
import accountingReconciliation from 'app/entities/accounting-reconciliation/accounting-reconciliation.reducer';
import accountingCollectionLedger from 'app/entities/accounting-collection-ledger/accounting-collection-ledger.reducer';
import accountingTransactionBill from 'app/entities/accounting-transaction-bill/accounting-transaction-bill.reducer';
import accountingExpenseLedger from 'app/entities/accounting-expense-ledger/accounting-expense-ledger.reducer';
import accountingTax from 'app/entities/accounting-tax/accounting-tax.reducer';
import workFlowStepLog from 'app/entities/work-flow-step-log/work-flow-step-log.reducer';
import accountingBankAccount from 'app/entities/accounting-bank-account/accounting-bank-account.reducer';
import pharmacySaleCredit from 'app/entities/pharmacy-sale-credit/pharmacy-sale-credit.reducer';
import sampleContainerTestSample from 'app/entities/sample-container-test-sample/sample-container-test-sample.reducer';
import operationTheatreEquipment from 'app/entities/operation-theatre-equipment/operation-theatre-equipment.reducer';
import pharmacySaleCreditPaymentTracker from 'app/entities/pharmacy-sale-credit-payment-tracker/pharmacy-sale-credit-payment-tracker.reducer';
import diaglabDepartmentAccess from 'app/entities/diaglab-department-access/diaglab-department-access.reducer';
import labTestItemAttribute from 'app/entities/lab-test-item-attribute/lab-test-item-attribute.reducer';
import rxCalculatorFormula from 'app/entities/rx-calculator-formula/rx-calculator-formula.reducer';
import diaglabTestThreshold from 'app/entities/diaglab-test-threshold/diaglab-test-threshold.reducer';
import treatmentSessionVitals from 'app/entities/treatment-session-vitals/treatment-session-vitals.reducer';
import regimenInvestigation from 'app/entities/regimen-investigation/regimen-investigation.reducer';
import treatmentRegimenInvestigation from 'app/entities/treatment-regimen-investigation/treatment-regimen-investigation.reducer';
import treatmentRegimenInvestigationObs from 'app/entities/treatment-regimen-investigation-obs/treatment-regimen-investigation-obs.reducer';
import catalogDefinitions from 'app/entities/catalog-definitions/catalog-definitions.reducer';
import organism from 'app/entities/organism/organism.reducer';
import antibiotic from 'app/entities/antibiotic/antibiotic.reducer';
import labTestItemOrganismAntibiotic from 'app/entities/lab-test-item-organism-antibiotic/lab-test-item-organism-antibiotic.reducer';
import patientOrganismAntibioticSusceptibility from 'app/entities/patient-organism-antibiotic-susceptibility/patient-organism-antibiotic-susceptibility.reducer';
import resistanceTrend from 'app/entities/resistance-trend/resistance-trend.reducer';
import bloodBankInventory from 'app/entities/blood-bank-inventory/blood-bank-inventory.reducer';
import bloodBankRequest from 'app/entities/blood-bank-request/blood-bank-request.reducer';
import bloodInventoryRequestMap from 'app/entities/blood-inventory-request-map/blood-inventory-request-map.reducer';
import bloodBank from 'app/entities/blood-bank/blood-bank.reducer';
import bloodBankEmployee from 'app/entities/blood-bank-employee/blood-bank-employee.reducer';
import bloodDonation from 'app/entities/blood-donation/blood-donation.reducer';
import bloodDonorFitness from 'app/entities/blood-donor-fitness/blood-donor-fitness.reducer';
import healthCamp from 'app/entities/health-camp/health-camp.reducer';
import bloodInventoryInvestigation from 'app/entities/blood-inventory-investigation/blood-inventory-investigation.reducer';
import bloodBankInvestigationList from 'app/entities/blood-bank-investigation-list/blood-bank-investigation-list.reducer';
import bloodBankAccess from 'app/entities/blood-bank-access/blood-bank-access.reducer';
import bloodBankAssociation from 'app/entities/blood-bank-association/blood-bank-association.reducer';
import bloodBankAdverseEvent from 'app/entities/blood-bank-adverse-event/blood-bank-adverse-event.reducer';
import integrationChannel from 'app/entities/integration-channel/integration-channel.reducer';
import integrationEndpoint from 'app/entities/integration-endpoint/integration-endpoint.reducer';
import integrationEndpointAttribute from 'app/entities/integration-endpoint-attribute/integration-endpoint-attribute.reducer';
import integrationTemplate from 'app/entities/integration-template/integration-template.reducer';
import tenantIntegrationChannel from 'app/entities/tenant-integration-channel/tenant-integration-channel.reducer';
import tenantIntegrationEndpointAttribute from 'app/entities/tenant-integration-endpoint-attribute/tenant-integration-endpoint-attribute.reducer';
import tenantIntegrationTemplate from 'app/entities/tenant-integration-template/tenant-integration-template.reducer';
import communicationLog from 'app/entities/communication-log/communication-log.reducer';
import dataCategory from 'app/entities/data-category/data-category.reducer';
import integrationTemplateCategory from 'app/entities/integration-template-category/integration-template-category.reducer';
import tenantIntegrationTemplateCategory from 'app/entities/tenant-integration-template-category/tenant-integration-template-category.reducer';
import hospitalProcedureItem from 'app/entities/hospital-procedure-item/hospital-procedure-item.reducer';
import healthCampParticipant from 'app/entities/health-camp-participant/health-camp-participant.reducer';
import healthCampTransaction from 'app/entities/health-camp-transaction/health-camp-transaction.reducer';
import approvedRefund from 'app/entities/approved-refund/approved-refund.reducer';
import externalReferral from 'app/entities/external-referral/external-referral.reducer';
import healthCampRegistration from 'app/entities/health-camp-registration/health-camp-registration.reducer';
import tenant from 'app/entities/tenant/tenant.reducer';
import tenantEmployee from 'app/entities/tenant-employee/tenant-employee.reducer';
import tenantAccess from 'app/entities/tenant-access/tenant-access.reducer';
import tenantAssociation from 'app/entities/tenant-association/tenant-association.reducer';
import tinymedicPatientOrder from 'app/entities/tinymedic-patient-order/tinymedic-patient-order.reducer';
import tenantBids from 'app/entities/tenant-bids/tenant-bids.reducer';
import tenantBidItem from 'app/entities/tenant-bid-item/tenant-bid-item.reducer';
import tenantBidPayment from 'app/entities/tenant-bid-payment/tenant-bid-payment.reducer';
import tenantBidShipment from 'app/entities/tenant-bid-shipment/tenant-bid-shipment.reducer';
import tinymedicPatientOrderFile from 'app/entities/tinymedic-patient-order-file/tinymedic-patient-order-file.reducer';
import doctorRegularMedicine from 'app/entities/doctor-regular-medicine/doctor-regular-medicine.reducer';
import doctorRegularInvestigation from 'app/entities/doctor-regular-investigation/doctor-regular-investigation.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  pharmacyReturnBillPayment,
  hospitalOPBillItem,
  personName,
  diaglabSampleItemStatus,
  admission,
  admissionAdvice,
  admissionEMContacts,
  aldreteScore,
  allergyLegend,
  allergySymptom,
  apgarScore,
  appointmentHistory,
  appointmentStatus,
  appointments,
  assessmentAnswer,
  assessmentQuestion,
  atendant,
  bed,
  bedAllotment,
  behaviouralPainScore,
  birthHistory,
  bookingType,
  cashTransaction,
  cholesterol,
  chronicCondition,
  combousers,
  conceptDataType,
  consumable,
  consumableGroup,
  consumableOrder,
  consumableOrderItem,
  contactDetails,
  device,
  deviceManufacurer,
  deviceType,
  diagLab,
  diaglabEquipment,
  diagLabPanel,
  diagLabPanelItem,
  diaglabAssistant,
  diaglabBill,
  diaglabBillItem,
  diaglabBillPayment,
  diaglabHistory,
  diaglabPricing,
  diaglabSampleItem,
  diaglabSample,
  diagnosisHistory,
  dischargeSummary,
  doctor,
  doctorAccess,
  doctorAssociation,
  doctorAvailability,
  doctorCharges,
  doctorDetails,
  doctorDiaglabAssociation,
  doctorEspecialty,
  doctorHospitalAssociation,
  duration,
  equipment,
  equipmentAllotment,
  equipmentIP,
  equipmentIPCharges,
  especialty,
  flaccScore,
  globalProperty,
  glucoUser,
  glucose,
  growthLegend,
  gynicHistory,
  hb1ac,
  hospital,
  hospitalAccess,
  hospitalAccountant,
  hospitalAppointments,
  hospitalAssistant,
  hospitalBill,
  hospitalBillDiscount,
  hospitalBillItem,
  hospitalInstitution,
  hospitalManager,
  hospitalPayment,
  hospitalProcedure,
  iCD10Diagnosis,
  iCD10Procedure,
  icdDetails,
  imageTests,
  implant,
  implantGroup,
  implantOrder,
  implantOrderItem,
  implantProperty,
  instance,
  institution,
  insuranceClaim,
  insuranceClaimHistory,
  insuranceClaimItem,
  insurancePolicy,
  intraOPChart,
  intraOPCount,
  intraOPNursingRecord,
  intraOPPack,
  intraOPRecovery,
  ketone,
  labAccess,
  labDepartment,
  labDepartmentItem,
  labHospitalAssociation,
  labItemMeasure,
  labPrescription,
  labTestCategory,
  labTestCategoryGroup,
  labTestCategoryItem,
  labTestGroupItem,
  labTestItem,
  labTestItemLimit,
  mPPS,
  mWLItem,
  meal,
  mealAdvise,
  mealDetails,
  mealNutrition,
  mealPlan,
  mealSchedule,
  medicalAssociation,
  medicalHistory,
  medicationDetails,
  medicationMedicines,
  medicationSchedule,
  medicationScheduleDetails,
  medicine,
  moduleLogo,
  nipsScore,
  nurse,
  nursingNotes,
  nutritionIP,
  nutritionOrder,
  nutritionOrderItem,
  nutritionPlan,
  nutritionPlanIP,
  nutritionist,
  nutrtion,
  nutrtiontags,
  obstetricEvent,
  opMedication,
  otherVitals,
  paediatricParams,
  patientCondition,
  patientConditionCheckUp,
  patientIdentifierName,
  patientIdentifier,
  patientIdentifierType,
  patientMarker,
  patientNutritionPlan,
  patientProcedure,
  patientProcedureConsumable,
  patientProcedureImplant,
  patientProcedureMedicine,
  patientProcedureOrder,
  patientProcedurePlan,
  patientProcedureInvestigation,
  patientSurvey,
  patientSurveySections,
  patientVolunteer,
  paymentScheme,
  patientName,
  pharmacist,
  pharmacy,
  pharmacyAccess,
  pharmacyBill,
  pharmacyBillItem,
  pharmacyBillPayment,
  pharmacyConsumableBillItem,
  pharmacyConsumableRefundBillItem,
  pharmacyConsumableStock,
  pharmacyDrugBrandNames,
  pharmacyHistory,
  pharmacyHospitalAssociation,
  pharmacyImplantBillItem,
  pharmacyImplantRefundBillItem,
  pharmacyImplantStock,
  pharmacyPaymentHistory,
  pharmacyRefundBill,
  pharmacyRefundBillItem,
  pharmacyRefundPayment,
  pharmacyStock,
  pharmacyStockBill,
  pharmacySuppliers,
  physioCategory,
  physioCategoryItem,
  physioItem,
  physioOrder,
  physioOrderItem,
  physioTherapist,
  postOPInstruction,
  postOPRecoveryRecord,
  postOPSurgeonNotes,
  postOpRecovery,
  postOpRecoveryDischarge,
  preAssessment,
  preOPTimeOut,
  preOpAddlAssessment,
  preOpAnaesthesiaChart,
  preOpAssessment,
  preOpCheckList,
  preOpInstructions,
  preOpReviewPAC,
  preOpSignIn,
  prescription,
  prescriptionSpecVital,
  pressure,
  procedureBloodProducts,
  procedureConsumable,
  procedureImplant,
  procedureMedicine,
  procedureMonitors,
  procedurePrice,
  procedureInvestigation,
  providedItem,
  radiologyBillItem,
  radiologyPricing,
  radiologyReport,
  radiologyReportTemplate,
  radiologyStudy,
  recipe,
  recipeTags,
  referral,
  relation,
  relatives,
  reminderOptions,
  reminders,
  roles,
  room,
  saluation,
  series,
  specialityVitals,
  study,
  subscriptionBilling,
  subscriptionPayment,
  subscriptionPlan,
  surveyAnswer,
  surveyComments,
  surveyHeaders,
  surveyInputType,
  surveyOptionChoice,
  surveyOptionGroup,
  surveyQuestion,
  surveyQuestionOption,
  surveySections,
  surveyUnitsOfMeasure,
  templateDiagnosis,
  templateInvestigation,
  templateMedication,
  templatePrescription,
  templateSchedule,
  treatmentHistory,
  treatmentNotes,
  treatmentPlan,
  userAdditionalHistory,
  userAllergies,
  userLabItemEnum,
  userLabTestItem,
  userPanelItem,
  userRoles,
  userVaccinationScheduleDetails,
  vaccination,
  vaccinationSchedule,
  vaccinationScheduleDetails,
  vitals,
  volunteerVisits,
  ward,
  wardCharges,
  weight,
  wongBakersPainScore,
  entityAttribute,
  pharmacyLimit,
  operationTheatre,
  surgicalAppointment,
  surgicalAppointmentAttributeType,
  surgicalAppointmentAttribute,
  pharmacyReturnBill,
  pharmacyReturnBillItem,
  pharmacyConsumableReturnBillItem,
  pharmacyImplantReturnBillItem,
  pharmacyVendorPaymentTracker,
  oPCharge,
  pharmacyCredit,
  packageSubscription,
  packageSubscriber,
  packageSubscriptionDiscount,
  packagePaymentHistory,
  patientAccessGroup,
  pharmacyAuditSummary,
  pharmacyAuditItem,
  packageMedicine,
  customerCareExecutive,
  eventImage,
  dentalTooth,
  dentalSurface,
  dentalToothSurface,
  dentalMouthItem,
  dentalSurfaceErosion,
  dentalExamAndTreatment,
  pharmacyKit,
  pharmacyKitItem,
  procedureEpisode,
  patientProcedureEpisode,
  treatmentProcedure,
  pharmacyStockClosure,
  lensSpecification,
  lensPrescription,
  opProcedureOrder,
  opProcedureOrderItem,
  appointmentEpisode,
  bleeding,
  cervix,
  cycleDay,
  familyHistory,
  gynaecHistory,
  medicationHistory,
  mensesEvent,
  mucus,
  ovulation,
  pain,
  pastMedicalHistory,
  patientSymptomHistory,
  postDeliveryMonitoring,
  pregnancyCase,
  pregnancyPrescription,
  pregnancyVaccine,
  habitsHistory,
  sexualHistory,
  specialitySymptomPreferences,
  surgicalHistory,
  symptom,
  temperature,
  trimesterObservation,
  patientAttributeType,
  patientAttribute,
  paramedic,
  paramedicReferral,
  paramedicReferralCharge,
  paramedicReferralPayment,
  paramedicHospitalAssociation,
  urlSlug,
  facilityLocation,
  paramedicAccess,
  pharmacyStockIndentItem,
  pharmacyStockIndentMap,
  diagLabInventoryType,
  diagLabInventory,
  diagLabInventoryInvestigation,
  diagLabSupplier,
  pharmacyStockIndent,
  diagLabInventoryCheckout,
  language,
  trimester,
  paramedicOrder,
  doctorLanguage,
  laborIncident,
  laborProgression,
  trimesterObservationParam,
  specVitalResult,
  admissionAuxPatient,
  admissionConsultant,
  gynaecChecklist,
  patientCategory,
  miscCharges,
  hospitalPatientCategoryAttributes,
  hospPatientCatMiscCharges,
  hospitalPatientAttribute,
  doctorHospitalAttribute,
  dayOff,
  department,
  nurseDepartment,
  departmentNeed,
  nurseAttribute,
  schedule,
  shift,
  departmentWard,
  paymentCommunity,
  schemeCommunity,
  departmentSpeciality,
  diagLabInventoryBill,
  symptomAttributePreference,
  symptomAttribute,
  patientSymptomAttribute,
  conceptTerms,
  userAttribute,
  pharmacyConsumer,
  pharmacyExternalOrder,
  pharmacyExternalOrderItem,
  pharmacyExternalOrderShipment,
  pharmacyExternalOrderShipmentItem,
  eye,
  pharmacyMiscBillItem,
  tumorMeasurement,
  clinicalDictionaryType,
  clinicalDictionary,
  tumor,
  tumorSource,
  treatmentTemplate,
  treatmentTemplateComponent,
  regimen,
  regimenChecklistItem,
  radiationType,
  radiationTechnique,
  dosageGuideline,
  dosageDilution,
  frequency,
  sequence,
  regimenDrug,
  radiationSession,
  organAtRisk,
  radiationConstraint,
  radiationBeamParameter,
  radiationDosimetry,
  regimenCycle,
  regimenAdverseEvent,
  drugConstraint,
  treatmentDeliveryPlan,
  treatmentRegimen,
  treatmentCycle,
  treatmentCycleCheckListItem,
  treatmentDrug,
  treatmentRadiation,
  treatmentRadiationBeamParam,
  treatmentRadiationDosimetry,
  treatmentOrganAtRisk,
  treatmentTumor,
  treatmentRadiationTechnique,
  treatmentContouring,
  treatmentAssessment,
  treatmentAdverseEvent,
  tumorBoard,
  tumorBoardMember,
  tumorStaging,
  tumorBoardOccurrenceParticipant,
  tumorBoardOutcome,
  tumorBoardParticipantOutcome,
  tumorBoardReferral,
  tumorBoardOccurrence,
  tumorBoardPatient,
  doctorAvailabilitySlot,
  bedAllotmentCharge,
  equipmentAllotmentCharge,
  patientProcedureCharge,
  productTag,
  tenantPaymentGateway,
  paymentGateway,
  tenantGatewayTransaction,
  pharmacySupplierAttribute,
  intraOPInvestigation,
  productAttributeType,
  productAttribute,
  sampleContainerType,
  hospitalProcedureSpeciality,
  workFlowProtocol,
  workFlowStep,
  workFlowProtocolLog,
  accountingCurrency,
  accountingTransaction,
  accountingReconciliation,
  accountingCollectionLedger,
  accountingTransactionBill,
  accountingExpenseLedger,
  accountingTax,
  workFlowStepLog,
  accountingBankAccount,
  pharmacySaleCredit,
  sampleContainerTestSample,
  operationTheatreEquipment,
  pharmacySaleCreditPaymentTracker,
  diaglabDepartmentAccess,
  labTestItemAttribute,
  rxCalculatorFormula,
  diaglabTestThreshold,
  treatmentSessionVitals,
  regimenInvestigation,
  treatmentRegimenInvestigation,
  treatmentRegimenInvestigationObs,
  catalogDefinitions,
  organism,
  antibiotic,
  labTestItemOrganismAntibiotic,
  patientOrganismAntibioticSusceptibility,
  resistanceTrend,
  bloodBankInventory,
  bloodBankRequest,
  bloodInventoryRequestMap,
  bloodBank,
  bloodBankEmployee,
  bloodDonation,
  bloodDonorFitness,
  healthCamp,
  bloodInventoryInvestigation,
  bloodBankInvestigationList,
  bloodBankAccess,
  bloodBankAssociation,
  bloodBankAdverseEvent,
  integrationChannel,
  integrationEndpoint,
  integrationEndpointAttribute,
  integrationTemplate,
  tenantIntegrationChannel,
  tenantIntegrationEndpointAttribute,
  tenantIntegrationTemplate,
  communicationLog,
  dataCategory,
  integrationTemplateCategory,
  tenantIntegrationTemplateCategory,
  hospitalProcedureItem,
  healthCampParticipant,
  healthCampTransaction,
  approvedRefund,
  externalReferral,
  healthCampRegistration,
  tenant,
  tenantEmployee,
  tenantAccess,
  tenantAssociation,
  tinymedicPatientOrder,
  tenantBids,
  tenantBidItem,
  tenantBidPayment,
  tenantBidShipment,
  tinymedicPatientOrderFile,
  doctorRegularMedicine,
  doctorRegularInvestigation,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
